import { getMessages } from '../../../../../../../../store/constants';

export const MY_WORK_SETTINGS_COLUMNS_TITLE = getMessages().getText('assigned_to_me.settings.columns.title');
export const MY_WORK_SETTINGS_COLUMNS_RESET = getMessages().getText('assigned_to_me.settings.columns.reset');
